import React, { Component } from 'react'
import parse from 'html-react-parser'

import { DownArrow } from './icons'

class InteractiveBanner extends Component {

  colors = {
    base: '#08141A',
    hover: '#0c1c24',
    active: '#00D991',
    white: '#ffffff',
  }

  state = {
    rw: '100vw',
    rh: '100vh'
  }

  componentDidMount() {
    this.initCanvas()
    this.drawLetter()
    this.bindEvents()
  }

  bindEvents() {
    // Mouse Move
    document.getElementById('banner').addEventListener('mousemove', (event) => {
      const pos = event.currentTarget.getBoundingClientRect();
      const { clientX, clientY } = event
      let x = Math.floor((clientX - pos.left) / 45)
      let y = Math.floor((clientY - pos.top) / 45)

      if (this.checkColour(this.ctx.getImageData(x*45 + 20, y*45 + 20, 1, 1).data)) return;
      this.ctx.fillStyle = this.colors.hover;
      this.roundedRect(x*45 + 1, y*45 + 1, 43, 43, 2)

      setTimeout(() => {
        if (this.checkColour(this.ctx.getImageData(x*45 + 20, y*45 + 20, 1, 1).data)) return;
        this.ctx.fillStyle = this.colors.base;
        this.roundedRect(x*45 + 1, y*45 + 1, 43, 43, 2)
      }, 400)

    })

    // Mouse Down
    document.getElementById('banner').addEventListener('mousedown', (event) => {
      const pos = event.currentTarget.getBoundingClientRect();
      const { clientX, clientY } = event
      let x = Math.floor((clientX - pos.left) / 45)
      let y = Math.floor((clientY - pos.top) / 45)

      if (this.checkColour(this.ctx.getImageData(x*45 + 20, y*45 + 20, 1, 1).data)) {
        this.ctx.fillStyle = this.colors.base;
      } else {
        this.ctx.fillStyle = this.colors.active;
      }
      this.roundedRect(x*45 + 1, y*45 + 1, 43, 43, 2)
      //console.log(x, y)
    })

    // Resize
    window.addEventListener('resize', (event) => {
      this.initCanvas()
    })
  }

  checkColour(rgba) {
    return (rgba[0] === 0 && rgba[1] === 217 && rgba[2] === 145)
  }

  roundedRect(x, y, width, height, radius) {
    this.ctx.beginPath();
    this.ctx.moveTo(x, y + radius);
    this.ctx.arcTo(x, y + height, x + radius, y + height, radius);
    this.ctx.arcTo(x + width, y + height, x + width, y + height - radius, radius);
    this.ctx.arcTo(x + width, y, x + width - radius, y, radius);
    this.ctx.arcTo(x, y, x, y + radius, radius);
    this.ctx.fill();
  }

  drawLine(x1, y1, x2, y2) {
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);
    this.ctx.lineTo(x2, y2);
    this.ctx.stroke();
  }

  initCanvas() {
    this.canvas = document.getElementById('canvas')
    if (!this.canvas.getContext) return false
    this.ctx = this.canvas.getContext('2d')

    this.canvas.width = window.innerWidth
    this.canvas.height = window.innerHeight

    let { width, height } = this.canvas

    this.grid = []
    // x, y, w, h
    for (let x = 0, xl = Math.round(width / 45); x < xl; x++) {
      this.grid.push([])
      for (let y = 0, yl = Math.round(height / 45); y < yl; y++) {
        this.grid[x].push(y)
        this.ctx.fillStyle = this.colors.base;
        this.roundedRect(x*45 + 1, y*45 + 1, 43, 43, 2)
      }
    }

    // Draw cross hair
    //this.ctx.strokeStyle = this.colors.active;
    //this.ctx.fillStyle = this.colors.active;
    let rw = Math.ceil(width * 0.70 / 45) * 45 + 'px'
    let rh = Math.ceil(height * 0.66 / 45) * 45 + 'px'
    this.setState({ rw, rh })
    //this.drawLine(rw, 0, rw, height);
    //this.drawLine(0, rh, width, rh);
  }

  drawLetter() {
    const data = [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4], [1, 2], [2, 2], [3, 2], [3, 3], [3, 4]]
    const { width, height } = this.canvas
    const xposmod = 1.8
    const yposmod = 2.6

    data.forEach((el, i) => {
      setTimeout(() => {
        this.ctx.fillStyle = this.colors.active;
        let x = el[0] + Math.round(width / 45 / xposmod)
        let y = el[1] + Math.round(height / 45 / yposmod)
        this.roundedRect(x*45 + 1, y*45 + 1, 43, 43, 2)
      }, i * 150 + 1000)
    })

    const whitedot = [3, 0]
    setTimeout(() => {
      this.ctx.fillStyle = this.colors.white;
      let x = whitedot[0] + Math.round(width / 45 / xposmod)
      let y = whitedot[1] + Math.round(height / 45 / yposmod)
      this.roundedRect(x*45 + 1, y*45 + 1, 43, 43, 2)
    }, data.length * 150 + 1150)
  }

  clearCanvas = () => {
    this.initCanvas()
  }

  scrollDown = () => {
    window.scrollTo({ left: 0, top: window.innerHeight, behavior: "smooth" });
  }

  render() {
  	const { title, subtitle } = this.props
    let { rw, rh } = this.state

    return (
      <section id='banner' className='interactive-banner'>
        <div className='interactive-banner__container'>

          <canvas id='canvas' />

          <div className='line vert' style={{left: rw}} />
          <div className='line hori' style={{top: rh}} />
          <div className='line vert' style={{left: `calc(60vw + ${rw})`}} />
          <div className='line hori' style={{top: `calc(100vh + ${rh})`}} />

          <div className='interactive-banner__inner'>
            <div className='interactive-banner__content'>
              <div>
                <h2 className='title'>{ title }</h2>
              </div>

              <div className='interactive-banner__subtitle'>
                { parse(subtitle) }
                <button
                  onClick={this.clearCanvas}
                  className='interactive-banner__clear'>
                  Clear <span>pixels</span>
                </button>
              </div>
            </div>

            <button className='interactive-banner__arrow' onClick={this.scrollDown}>
              <DownArrow color={'#00D991'} />
            </button>

            <div className='interactive-banner__overflow-text'>Enabling Innovation</div>
          </div>

        </div>
      </section>
    )
  }
}

export default InteractiveBanner
